export const BaseExternalUrls = {
  CONTACT: 'https://stazzle.de/#kontakt',
  IMPRINT: 'https://stazzle.de/impressum/',
  PRIVACY_POLICY: 'https://stazzle.de/stazzle-datenschutzbestimmungen/',
  TERMS_OF_USE: 'https://stazzle.de/stazzle-nutzungsbedingungen/',
  HELP_PSP: 'https://stazzle.de/hc/psp',
  HELP_CUSTOMER: 'https://stazzle.de/hc/cus',
  DPA_PSP: 'https://stazzle.de/stazzle-avv/',
};
